import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledDatabaseEntitiesTableViews
  from 'components/organisms/TableViews/DatabaseEntitiesTableViews/DatabaseEntitiesTableViews.styles';

const DatabaseEntitiesTableViews = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DatabaseEntitiesTableViews');

  const handleCanNotify = () => {
    return false;
  }

  return <StyledDatabaseEntitiesTableViews ref={ref} {...innerProps}
                                           onCanNotify={handleCanNotify}>
    {innerProps.children}
  </StyledDatabaseEntitiesTableViews>
});

DatabaseEntitiesTableViews.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DatabaseEntitiesTableViews;
